import React from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from './ui/Accordion';
export function FAQ() {
  const faqs = [{
    question: 'Do you bring your own supplies?',
    answer: 'Yes, we bring all our own professional-grade cleaning supplies and equipment. If you have specific products you prefer us to use, just let us know.'
  }, {
    question: 'Are you insured?',
    answer: 'Absolutely. We are fully insured for both residential and commercial cleaning, giving you complete peace of mind.'
  }, {
    question: 'Do you offer recurring discounts?',
    answer: 'Yes! We offer discounted rates for our weekly, bi-weekly, and monthly recurring cleaning plans.'
  }, {
    question: 'What areas do you serve?',
    answer: 'We proudly serve Far East El Paso, Horizon City, Socorro, Clint, and Fabens.'
  }, {
    question: 'How do I get a quote?',
    answer: 'Simply fill out the form below or give us a call. We will discuss your needs and provide a clear, flat-rate quote with no hidden fees.'
  }, {
    question: 'Do you offer bilingual service?',
    answer: 'Yes, our entire team is fully bilingual in English and Spanish to ensure clear communication.'
  }];
  return <section className="py-20 md:py-28 bg-white" data-id="element-14">
      <div className="container mx-auto px-4" data-id="element-15">
        <div className="text-center max-w-2xl mx-auto mb-16" data-id="element-16">
          <span className="text-brand-green font-semibold tracking-wider uppercase text-sm mb-3 block" data-id="element-17">
            Good to Know
          </span>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-brand-navy" data-id="element-18">
            Frequently Asked Questions
          </h2>
        </div>

        <div className="max-w-3xl mx-auto" data-id="element-19">
          <Accordion type="single" collapsible className="w-full space-y-4" data-id="element-20">
            {faqs.map((faq, index) => <AccordionItem key={index} value={`item-${index}`} className="border border-gray-200 rounded-xl px-6 bg-gray-50/50 data-[state=open]:bg-white data-[state=open]:shadow-sm transition-all" data-id="element-21">
                <AccordionTrigger className="text-left font-heading font-semibold text-lg text-gray-900 hover:no-underline py-6" data-id="element-22">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-gray-600 font-body text-base leading-relaxed pb-6" data-id="element-23">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>
      </div>
    </section>;
}